export default __webpack_public_path__ + "static/media/supplier_he.e37f0313.svg";